import normalizeUrl from 'normalize-url';

const config = {
  apiEndPoint: normalizeUrl(window.env.REACT_APP_API_ENDPOINT, {
    removeSingleSlash: true,
  }),
  cdnUrl: normalizeUrl(window.env.REACT_APP_BASE_URL, {
    removeSingleSlash: true,
  }),
  imageTransformerUrl: normalizeUrl(window.env.REACT_APP_IMAGE_TRANSFORMER_URL, {
    removeSingleSlash: true,
  }),
  cdnBucket: window.env.REACT_APP_CDN_BUCKET,
  socketHost: window.env.REACT_APP_SOCKET_HOST ?? 'http://localhost',
  socketPath: window.env.REACT_APP_SOCKET_PATH ?? '/push/socket.io',
  keycloakEndPoint: window.env.REACT_APP_KEYCLOAK_ENDPOINT || 'http://localhost:8080',
  matrixEndPoint: window.env.REACT_APP_MATRIX_URL,
  debounceWait: window.env.REACT_APP_DEBOUNCE_WAIT || 1000,
  discordInviteUrl: window.env.REACT_APP_DISCORD_INVITE_URL || 'https://discord.com/invite/GvpZhNq',
  refundPolicyUrl:
    window.env.REACT_APP_REFUND_POLICY_URL || 'https://docs.okletsplay.com/legal/refund-policy',
  privacyPolicyUrl:
    window.env.REACT_APP_PRIVACY_POLICY_URL || 'https://docs.okletsplay.com/legal/privacy-policy',
  termsOfUseUrl:
    window.env.REACT_APP_TERMS_OF_USE_URL || 'https://docs.okletsplay.com/legal/terms-of-service',
  frontendEnvironment: window.env.REACT_APP_FRONTEND_ENVIRONMENT || 'local',
  sentryDns: window.env.REACT_APP_SENTRY_DSN,
  riotMinPlayersAmount: window.env.RIOT_MIN_PLAYERS_AMOUNT || 20,
  talkJsAppId: window.env.TALK_JS_APP_ID,
  discordServerId: window.env.REACT_APP_DISCORD_SERVER_ID,
  discordChannelId: window.env.REACT_APP_DISCORD_CHANNEL_ID,
  blockchainLinkBaseUrl:
    window.env.REACT_APP_BLOCKCHAIN_LINK_BASE_URL || 'https://mumbai.polygonscan.com/search?f=0&q=',
  timeToTournamentCheckIn: window.env.REACT_APP_TIME_TILL_TOURNAMENT_CHECK_IN || 1800,
  gtmId: window.env.REACT_APP_GTM_ID,
  refreshLeaderboardInterval: window.env.REACT_APP_REFRESH_LEADERBOARD_INTERVAL || 300,
  features: {
    registration: window.env.REACT_APP_REGISTRATION_FEATURE_SECRET,
  },
  multiCurrencyFeatures: window.env.TATUM_ENABLED_MULTI_CURRENCY_FEATURES,
  globalAlertMessage: window.env.REACT_APP_GLOBAL_ALERT_MESSAGE ?? 'Off',
  rampWidgetUrl: window.env.RAMP_WIDGET_URL || 'https://app.demo.ramp.network',
  rampHostApiKey: window.env.RAMP_HOST_API_KEY,
  rampWebhookStatusUrl: window.env.RAMP_WEBHOOK_STATUS_URL,
  rampDefaultTokenName: window.env.RAMP_DEFAULT_TOKEN_NAME,
  rampMinTokensAmount: window.env.RAMP_MIN_TOKENS_AMOUNT || 4,
  isPaypalLinkEnabled: window.env.PAYPAL_LINK_ENABLED === 'true',
  paypalAllowedWithdrawRequestCountryCodes:
    window.env.PAYPAL_ALLOWED_WITHDRAW_REQUEST_COUNTRY_CODES,
  affiliateProgramFeatures: window.env.AFFILIATE_PROGRAM_FEATURE_FLAGS,
};
export default config;
